// import { createApp } from 'vue'
// import App from './App.vue'

// createApp(App).mount('#app')


import { createApp } from "vue";


import App from './App.vue';
import router from './router'; // 第一步

import i18n from './locales/index'; 
 
 import domain from '../public/domain';

 
 
 global.domain = domain;

const app = createApp(App);
app.use(router);              // 第二步
app.use(i18n);

app.mount('#app');

